// extracted by mini-css-extract-plugin
export default {"delete-matches-button-sm":"DeleteMatchButton_delete-matches-button-sm__NOZYl"};